<template>
  <div class="topbar">
    <div class="header font12">
      <div class="home" @click="toIndex">
        <img src="@/assets/public/homeY.png" alt />
        <span>首页</span>
      </div>
      <div class="page-left" :class="{ 'hover-area': areaBox }">
        <div @mouseenter="showArea" @mouseleave="areaBoxHoverOut">
          <div class="areaBox-shade" v-if="areaBox"></div>
          <span class="area line-city">{{ monitorId.shortName }}</span>
          &nbsp;
        </div>
        <div
          class="areaBox"
          v-show="areaBox"
          @mouseenter="showArea"
          @mouseleave="areaBoxHoverOut"
        >
          <div class="tc-10"></div>
          <div class="areaBoxInner">
            <div v-for="(item, index) in data1" :key="index">
              <a
                @click="selectArea(item, index)"
                :class="{
                  colorClass: (colorClass = item.id === monitorId.id),
                  'a-hover': !item.checked
                }"
              >
                {{ item.shortName }}
              </a>
            </div>
          </div>
          <div class="tc-5 clearboth"></div>
        </div>
      </div>
      <div class="right page-right normal">
        <div class="user-header">
          <!-- 切换用户身份下拉菜单 -->

          <div v-if="userInfo.id">
            <change-user-type />
          </div>

          <!-- 用户登录/退出/展示用户名区域 -->
          <div class="user-login">
            <!-- <div v-if="!$store.state.loginType"> -->
            <div v-if="!userInfo.id">
              <span class="color66">您好，请</span>
              <span class="color02 cursor-pointer" @click="loginIndex"
                >登录</span
              >
            </div>
            <!-- <div v-if="$store.state.loginType"> -->
            <div  v-if="userInfo.id">
              <span class="color02 cursor-pointer" @click="toPersonal">
                您好，{{
                  userInfo ? userInfo.realName || userInfo.accountName : ""
                }}
              </span>
            </div>

            <div class="dividing-line"></div>

            <div
              v-if="!$store.state.loginType"
              class="cursor-pointer color02"
              @click="tosign"
            >
              免费注册
            </div>
            <div
              class="cursor-pointer color66"
              v-if="$store.state.loginType"
              @click="quit"
            >
              退出
            </div>
          </div>

          <div class="cursor-pointer color66" @click="toPersonal">会员中心</div>

          <!-- 其他客户端二维码 -->
          <span class="cursor-pointer color66" @click="dialogVisible = true;loadType = 'app'">手机上经营帮</span>
          <DownloadApps
            @close="dialogVisible = false"
            :loadType="loadType"
            v-if="dialogVisible"
            :dialogVisible.sync="dialogVisible"
          />
          <div class="cursor-pointer color66">
            <span class="link" @click="downApp">下载工队到桌面</span>
          </div>

          <div class="cursor-pointer color66" @click="skipHelpCenter">
            帮助中心
          </div>
          <div
            @mouseenter="isShowCusServe = true"
            @mouseleave="isShowCusServe = false"
            class="cus_service_num"
          >
            <span class="color66">
              客服电话
              <i
                :class="{
                  'el-icon-arrow-up': isShowCusServe,
                  'el-icon-arrow-down': !isShowCusServe,
                  'active-up': isShowCusServe
                }"
              ></i>
            </span>
            <div v-show="isShowCusServe" class="cus_service_list">
              <div class="square">
                <div class="triangle"></div>
              </div>
              <ul>
                <li>
                  <span>售前电话</span>
                  <span class="list_phone">400-600-0115</span>
                </li>
                <li>
                  <span>售后电话</span>
                  <span class="list_phone">400-001-0051</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import link from "@/public/link.js"
import localStorage from "@/storage/localStorage"
import cookie from "@/storage/cookies.js"
import apiUser from "@/public/apiUser/apiUser"
import {getOS,getDownLoad} from '@/utils/downloadApp.js'
import {getPosition} from '@/storage/NewmapPosition.js'
export default {
  name: "Userinfo",
  data() {
    return {
      monitorId:{},
      dialogVisible: false,
      isShowCusServe: false,
      isShow: true,
      areaBox: false,
      colorClass: "",
      data1: [],
      shake: false,
      pushUserinfo: true,
      loadType: ''
    }
  },
  inject: ["reload"],
  components: {
    changeUserType: () => import("./ChangeUserType"),
    DownloadApps: () => import("./downloadApps")
  },
  mounted(){
    this.getMonitorId()
  },
  methods: {
    //下载到桌面更新(根据win系统提供不同地址)
    downApp(){
      // this.loadType = 'pc'
      // this.dialogVisible = true;
      let downUrl = getDownLoad(getOS())
      if(downUrl){
        let down = document.createElement("a");
        down.href = downUrl;
        down.click();
      }
    },
    downLoadApp(item) {
      if (item.type === "qrcode") {
        return false
      } else {
        if (item.downLink) {
          var a = document.createElement("a")
          var fileName = item.fileName
          a.download = fileName
          a.href = item.downLink
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      }
    },
    skipHelpCenter() {
      window.open(process.env.VUE_APP_HOME + "/content")
    },
    toPage(e) {
      if (this.userInfo.id) {
        let target = e.target || e.srcElement
        target.dataset.link && link[target.dataset.link]()
      } 
    },
    toPersonalOrLogin() {
      if (this.$store.state.loginType) {
        link.personal()
      } else {
        this.loginIndex()
      }
    },
    showArea() {
      if (this.data1.length === 0) {
        this.data1 = JSON.parse(localStorage.read("areaAll"))
        apiUser.getArea().then(res => {
          if (res.data.code === 200) {
          this.data1=res.data.data
          }
        })
      }
      this.areaBox = true
      this.shake = true
    },
    areaBoxHoverOut() {
      this.data1 = []
      let that = this
      this.shake = false
      setTimeout(function () {
        if (!that.shake) {
          that.areaBox = false
        }
      }, 50)
    },
    selectArea(val, index) {
      this.colorClass = index
      this.data1.forEach(item => {
        item.checked = false
      })
      val.checked = true
      this.areaBox = false
      cookie.cookieSet("area", JSON.stringify(val))
      localStorage.set("areaAll", JSON.stringify(this.data1))
      // this.$store.commit("SET_AREA", val);
      this.reload() // 重载
      // location.reload() // 重载
    },
    quit() {
      this.$confirm("确认退出？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async res => {
          await apiUser.logOut()
          this.$store.dispatch("zjkjIm/logout")
          this.$store.commit("LOGIN_OUT")
        })
        .catch(() => {})
    },
    pushThis() {
      let that = this
      this.pushUserinfo = false
      this.$nextTick(function () {
        that.pushUserinfo = true
      })
    },
    loginIndex() {
      let data = {
        callBack: function () {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    tosign() {
      link.sign()
    },
    toIndex() {
      link.index()
    },
    toPersonal() {
      if (this.$store.state.loginType) {
        link.personal()
      } else {
        this.loginIndex()
      }
    },
    toMyMessage() {
      link.myMessage()
    },
    //初次进来使用地图获取到的地区
    async getMonitorId(){
      if(cookie.cookieRead("area") &&JSON.stringify(cookie.cookieRead("area")) !== "{}"){
        let area = cookie.cookieRead("area");
        this.monitorId = JSON.parse(area);
      }else{
        let mapAddr = null;
        let data=[]
        mapAddr = await getPosition();
        apiUser.getArea().then(res => {
          if (res.data.code === 200) {
            data=res.data.data
          } 
          this.monitorId= data.find(item => {
          if (item.areaName.indexOf(mapAddr.address.province.substr(0, 2)) !== -1) {
            return item;
          }
        })
      cookie.cookieSet("area", JSON.stringify(this.monitorId))
      });
      }
    }
  },
  watch: {
    "$store.state.loginType": {
      handler(newValue) {
        if (newValue) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      },
      immediate: true
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user || {}
    }
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "@/styles/variable.scss";
$font_color: #737373;
@media screen and (min-width: 1200px) {
  .topbar {
    .header {
      width: 1200px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .topbar {
    .header {
      width: 1200px;
      > div:nth-child(1) {
        margin: 0 0 0 20px;
      }
    }
    .right {
      margin-right: 20px;
    }
  }
}
@media screen and (max-width: 992px) {
  .topbar {
    .header {
      width: 1200px;
    }
  }
}
.orange-color {
  color: #b79255;
}
.topbar {
  background: #f5f5f5;
  width: 100%;
  height: 30px;
  line-height: 30px;
  .clearboth {
    clear: both;
  }
  .hover-area {
    padding: 0 !important;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    background: #fff;
    height: 29px;
  }
  .header {
    margin: 0 auto;
    height: 30px;
    line-height: 30px;
    position: relative;
    > div {
      &:nth-child(1) {
        // padding: 1px 1px 0;
        text-indent: 10px;
        position: relative;
        // line-height: 29px;
        .areaBox-shade {
          position: absolute;
          height: 5px;
          z-index: 1000;
          width: 100%;
          background: #fff;
          left: 0px;
          bottom: -2px;
        }
      }
    }
    > div {
      &:nth-child(2) {
        padding: 1px 1px 0;
        text-indent: 10px;
        position: relative;
        line-height: 29px;
        .areaBox-shade {
          position: absolute;
          height: 5px;
          z-index: 1000;
          width: 100%;
          background: #fff;
          left: 0px;
          bottom: -2px;
        }
      }
    }
    .home {
      float: left;
      // border: 1px solid red;
      // display: inline-block;
      width: 70px;
      height: 100%;
      height: 30px;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #0286df;
      cursor: pointer;
      text-indent: 5px !important;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // color: rgba(2, 134, 223, 1);
        color: #c6a56f;
      }
    }
    .header-inner {
      margin-right: 25px !important;
    }
  }
  .icon {
    display: inline-block;
    width: 40px;
    height: 100%;
    text-align: center;
    &:hover {
      background: #fff;
    }
    > img {
      padding-top: 6px;
    }
  }
  .header-tel {
    margin-left: 20px;
    margin-right: 20px;
  }
  .image1-hover:hover .image1 {
    display: block;
  }
  .image2-hover:hover .image2 {
    display: block;
  }
  .image1-hover,
  .image2-hover {
    position: relative;
  }
  .image2-hover {
    margin-left: 5px;
  }
  .image1 {
    width: 162px;
    height: 183px;
    position: absolute;
    bottom: -183px;
    left: 0;
    z-index: 100;
    background: #fff;
    text-align: center;
    display: none;
    .image-box {
      margin: 0 auto;
      width: 120px;
      height: 120px;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .image-font {
      height: 20px;
    }
  }
  .image2 {
    width: 120px;
    height: 120px;
    position: absolute;
    bottom: -120px;
    left: 0;
    > img {
      width: 100%;
      height: 100%;
    }
    z-index: 100;
    display: none;
  }
  .right {
    ul {
      li {
        float: left;
        margin-right: 30px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          .menu {
            display: block;
          }
        }
        .el-icon-arrow-down {
          padding-left: 4px;
        }
        .background-line {
          position: absolute;
          right: -12px;
          top: -1px;
        }
        .menu {
          display: none;
          width: 350px;
          position: absolute;
          padding: 6px 0;
          left: 50%;
          top: 26px;
          margin-left: -150px;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 4px;
          z-index: 100;
          li {
            margin-right: 0;
            text-align: center;
            float: none;
            min-width: 98px;
            display: inline-block;
            &:hover {
              color: #c6a56f;
            }
          }
        }
      }
      .my-mess {
        padding-right: 8px;
        > div {
          position: absolute;
          width: 6px;
          height: 6px;
          background: rgba(253, 83, 83, 1);
          border-radius: 50%;
          right: 0px;
          top: 8px;
        }
      }
    }
  }
  .cus_service_num {
    cursor: pointer;
    position: relative;
    .active-up {
      color: #b79255;
    }
    .cus_service_list {
      position: absolute;
      width: 217px;
      height: 88px;
      background: #ffffff;
      right: 0;
      top: 46px;
      z-index: 22;
    .square {
      overflow: hidden;
      position: absolute;
      margin-left: 170px;
      margin-top: -7px;
      width: 10px;
      height: 7px;
      top: 2px;
    }
    .triangle {
      width: 0;
      height: 0;
      left: -5px;
      border-style: solid;
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent #fff transparent;
      position: absolute;
      top: 0;
      z-index: 1;
    }
    .triangle:before {
      content: "";
      position: absolute;
      top: 0px;
      left: -10px;
      width: 20px;
      height: 1px;
      background: #e4e7ed;
      transform: rotate(45deg);
    }
    .triangle::after {
      content: "";
      position: absolute;
      top: 0;
      left: -10px;
      width: 20px;
      height: 1px;
      background: #e4e7ed;
      transform: rotate(-45deg);
    }
    ul {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(179, 179, 179, 0.3);
      border: 1px solid #dcdfe8;
      border-radius: 4px;
      li {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        text-indent: 20px;
        height: 20px;
        line-height: 20px;
        > span {
          color: #666666;
            &.list_phone {
              color: #333333;
              text-indent: 10px;
            }
          }
        }
      }
    }
  }
  .area {
    background: url("../../../assets/public/locationY.png") no-repeat left 5px;
    text-indent: 20px;
  }

  .normal {
    font-weight: normal;
  }
  .line {
    display: inline-block;
    margin-right: 16px;
    color: $font_color;
  }

  .areaBox {
    left: -1px;
    top: 28px;
    width: 318px;
    min-height: 206px;
    border: 1px solid #e4e7ed;
    position: absolute;
    background-color: #ffffff;
    z-index: 999;
    .areaBoxInner {
      width: 300px;
      margin: 0 auto;
      > div {
        margin-bottom: 3px;
        width: 60px;
        // display: inline-block;
        float: left;
        height: 24px;
        line-height: 24px;
        a {
          text-indent: 0px;
          display: inline-block;
          padding: 0 6px;
          cursor: pointer;
          outline: none;
          color: #666666;
        }
        .a-hover {
          &:hover {
            background: #f5f5f5;
            // color: #0286df;
            color: #c6a56f;
          }
        }
      }
    }
  }

  .colorClass {
    // background-color: #0286df;
    background-color: #c6a56f;
    color: #ffffff !important;
  }
  .line-city {
    display: inline-block;
    // color: #0286df;
    color: #c6a56f;
    cursor: pointer;
  }
  .color02 {
    // color: #0286df;
    color: #c6a56f;
  }
}
.new-menu {
  padding: 0 0 !important;
  background: rgba(0, 0, 0, 0.4);
  .qrcode-wrap {
    padding: 10px 0;
    & > .box {
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 0 !important;
      text-align: center;
      margin-left: 10px;
      display: inline-block;
      padding: 15px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 8px;
      img {
        width: 115px;
        height: 115px;
      }
      > p {
        color: #f5f5f5;
      }
    }
    > .box:nth-of-type(1) {
      margin-right: 30px;
      margin-bottom: 30px;
    }
    > .box:nth-of-type(3) {
      margin-right: 30px;
    }
  }
}

tc-666 {
  color: #666666;
}
.user-header {
  display: flex;
  align-items: center;
  font-size: 12px;

  > div {
    padding: 0 15px;

    &:last-of-type {
      padding-right: 0;
    }
  }

  .link {
    color: #666666;
    text-decoration: none;
  }

  .user-login {
    display: flex;
    align-items: center;
  }

  .dividing-line {
    margin: 0 15px;
    height: 12px;
    width: 1px;
    background-color: #666666;
  }
  /deep/ .el-dialog {
    overflow: hidden;
    margin-top: 20px;
    .el-dialog__header {
      padding: 10px;
      padding-left: 20px;
      border-bottom: 1px solid #e4e7ed;
    }
    .el-dialog__body {
      padding: 20px;
      color: #333333;
    }
    .el-dialog__header {
      .el-dialog__title {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #000000;
      }
      .el-dialog__headerbtn {
        font-size: 24px;
        top: 12px;
      }
    }
  }
  .qrcode-download {
    &:hover {
      .menu {
        display: block;
      }
    }
    .el-icon-arrow-down {
      padding-left: 4px;
    }
    .background-line {
      position: absolute;
      right: -12px;
      top: -1px;
    }
    .menu {
      display: none;
      width: 350px;
      position: absolute;
      padding: 6px 0;
      left: 50%;
      top: 26px;
      margin-left: 50px;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      z-index: 100;
      li {
        margin-right: 0;
        text-align: center;
        float: none;
        min-width: 98px;
        display: inline-block;
        &:hover {
          color: #c6a56f;
        }
      }
    }
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
<style lang="scss">
.el-message-box{
  .el-button:focus, .el-button:hover {
    color: #B79255;
    border-color: #B79255;
    background-color: #fff;
   
}
 .el-button--primary:focus, .el-button--primary{
    background: #B79255;
    border-color: #B79255;
  }
  .el-button--primary:focus, .el-button--primary:hover{
    background: #B79255 ;
    border-color: #B79255;
     color: #fff;
  }
  .el-message-box__headerbtn:hover .el-message-box__close {
    color: #B7925511.21;
}
}
</style>
